<template>
  <el-dialog
    :visible="visible"

    :title="['create', 'commonCreate'].includes(mode) ? '添加节点' : '编辑节点'"
    width="550px"
    append-to-body
    @close="onEmitChange"
  >
    <el-form  :class="isDisabled" ref="rulesForm" :model="ruleForm" :rules="rules">
      <el-form-item :label-width="formLabelWidth" label="节点类型" prop="type">
        <el-select
          v-model="ruleForm.type"
          placeholder="请选择节点类型"
          class="width-layout"
          @change="handleType"
        >
          <el-option
            v-for="item in getNodeTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="ruleForm.type"
        :label-width="formLabelWidth"
        :label="`选择${typeLabel}`"
        prop="approverInfosList"
      >
        <accountUserSelect
          v-model="ruleForm.approverInfosList"
          :placeholder="`请选择${typeLabel}`"
          :multiple-limit="ruleForm.type === nodeTypeMap.SINGLE_APPROVE ? 1 : 0"
          :isDisabled="isDisabled"
        />
      </el-form-item>

      <el-form-item
        v-if="
          [nodeTypeMap.MULTIPLE_AND, nodeTypeMap.MULTIPLE_OR].includes(
            ruleForm.type
          )
        "
        :label-width="formLabelWidth"
        label="多人签批方式"
        prop="method"
      >
        <el-radio-group v-model="ruleForm.method">
          <el-radio
            v-for="item in approvalMethodList"
            :label="item.value"
            :key="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onEmitChange">取消</el-button>
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import accountUserSelect from './accountUserSelect'
import { config } from '../../config'
import mixin from '../../../mixins/auditFlowManage'

const { approvalMethodList, nodeTypeList, nodeTypeMap } = config
export default {
  name: 'nodeDialog',
  mixins: [mixin],
  components: {
    accountUserSelect,
  },
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeForm: {
      type: Object,
      default: () => ({}),
    },
    mode: {
      type: String,
      default: 'create',
    },

    nodeIndex: {
      type: Number,
      default: 0,
    },
    isDisabled: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      approvalMethodList,
      nodeTypeMap,
      formLabelWidth: '110px',
      ruleForm: {
        type: '',
        approverInfosList: [],
        method: '',
      },
      rules: {
        type: [
          { required: true, message: '请选择节点类型', trigger: 'change' },
        ],
        approverInfosList: [
          { required: true, message: '请选择', trigger: 'change' },
          { validator: this.validateApprove, trigger: 'blur' },
        ],
        method: [
          { required: true, message: '请选择多人签批方式', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    typeLabel() {
      return this.ruleForm.type === nodeTypeMap.CC_APPROVE ? '抄送人' : '审批人'
    },
    getNodeTypeList() {
      const { flowList = [] } = this.auditDetail
      const length =
        this.mode === 'create' ? flowList.length : flowList.length - 1
      // 展示抄送人
      if (this.nodeIndex && this.nodeIndex >= length) {
        return nodeTypeList
      }
      return nodeTypeList.filter(
        (item) => item.value !== nodeTypeMap.CC_APPROVE,
      )
    },
  },
  watch: {
    nodeForm: {
      handler(val) {
        const cloneVal = JSON.parse(JSON.stringify(val))
        this.ruleForm = cloneVal
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onEmitChange() {
      this.$emit('change', false)
    },
    handleType() {
      this.ruleForm.approverInfosList = []
      this.ruleForm.method = ''
    },
    onConfirm() {
      this.$refs.rulesForm.validate((validate) => {
        if (validate) {
          this.$emit('onConfirmNode', this.ruleForm)
          this.onEmitChange()
        }
      })
    },
    validateApprove(rule, value, callback) {
      const { type } = this.ruleForm
      if ([nodeTypeMap.MULTIPLE_AND, nodeTypeMap.MULTIPLE_OR].includes(type)) {
        if (value.length < 2) {
          callback(new Error('多人审批请至少选择2个审批人'))
          return
        }
      }
      callback()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
.width-layout {
  width: 100%;
}
</style>
